import { Injectable } from '@angular/core';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Injectable()
export class NgbLocalDateParserFormatter extends NgbDateParserFormatter {

    dateFormat = 'MM/dd/yyyy';

    format(date: NgbDateStruct): string {
        if (date === null) {
            return '';
        }
        const d = LocalDate.of(date.year, date.month, date.day);

        return d.format(DateTimeFormatter.ofPattern(this.dateFormat));
    }

    parse(value: string): NgbDateStruct {
        if (!value) {
            return null;
        }
        if (value.length === 10) {
            const d = LocalDate.parse(value, DateTimeFormatter.ofPattern('MM/dd/yyyy'));
            if (d) {
                return {
                    year: d.year(),
                    month: d.monthValue(),
                    day: d.dayOfMonth()
                };
            }
        } else {
            return null;
        }
    }

    toISODateStr(date: NgbDateStruct): string {
        return date ? LocalDate.of(date.year, date.month, date.day).toString(): '';
    }
}
